import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import background from "./background.png";
import "./joinRoomLogin.css";
import logo from "./logo.png";

const Joinroomlogin = () => {
  const history = useHistory();
  const urlparams = new URLSearchParams(window.location.search);
  const roomId = urlparams.get("id");
  const username = urlparams.get("user");
  const type = urlparams.get("type");
  const [showModal, setShowModal] = useState(false);

  const [loginInput, setLogin] = useState({
    user_name: username,
    password: "",
    error_list: [],
  });

  useEffect(() => {}, []);

  const handleSubmit = (e) => {
    setShowModal(true);
    e.preventDefault();
    const data = {
      username: loginInput.user_name,
      password: loginInput.password,
    };

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/user_authentication`, data).then((res) => {
        if (res.data.status === 200) {
          localStorage.setItem("auth_token", res.data.token);
          localStorage.setItem("auth_name", res.data.name);
          localStorage.setItem("auth_id", res.data.id);
          setShowModal(false);
          if (type === "liveChat") {
            history.push(`/live-chat/video-call?id=${roomId}`);
          } else if (type === "learningSession") {
            history.push(`/learning-session/live_stream?id=${roomId}`);
          } else if (type === "meetup") {
            history.push(`/meetup-session/live_stream?id=${roomId}`);
          }
        } else {
          setLogin({ ...loginInput, error_list: res.data.validation_errors });
        }
      });
    });
  };

  const handleInput = (e) => {
    e.persist();
    setLogin({ ...loginInput, [e.target.name]: e.target.value });
  };

  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
      className="loginBg"
    >
      <div>
        <div className="d-flex justify-content-center">
          <img src={logo} className="img-fluid img-logo" alt="" />
        </div>
        <div className="loginBorder text-center my-3 p-3">
          <h3 className="text-warning p-3">Join Room</h3>

          <div className="p-2">
            <input
              className="inputName text-center"
              placeholder="Enter Password"
              onChange={handleInput}
              type="password"
              name="password"
            />
            <br></br>
            <small className="text-danger">
              {loginInput.error_list?.password}
            </small>
          </div>

          <button className="btn btn-warning m-3" onClick={handleSubmit}>
            Enter
          </button>
        </div>
      </div>

      <Modal
        show={showModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="bg-dark rounded">
          <div className="d-flex justify-content-end">
            {/* <button className="closeNotificationDrop text-center">X</button> */}
          </div>
          <div className="text-center col-md-12">
            <h4 className="text-center text-warning my-3">Please Wait</h4>
          </div>
          <div className="d-flex justify-content-center">
            <Spinner
              className="spinnerLoad m-4"
              animation="border"
              variant="warning"
              style={{ fontSize: "50px", height: "100px", width: "100px" }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Joinroomlogin;
